
























































































































import { Component, Vue } from 'vue-property-decorator';
import storage from '../../utils/storage';
import Loading from '../../components/Loading.vue';
import moment from 'moment';
import { Debounced } from '../../utils/debounced';
@Component({
  components: {
    Loading,
  },
})
export default class PurchaseingList extends Vue {
  private user: any;
  private spinning = false;
  private moment: any = moment;
  private dataJson: any = [];
  private searchPM: string = '家伟';
  private searchAsin: string = '';
  private searchFactory: string = '';
  private selectDataJson: any = [];
  private applyStatusArr: any = [
    {name: '正在采购'},
    {name: '历史采购'},
  ];
  private searchProductNameAsinJson: any = [];
  private last: number = 0;
  private searchProductName: string = '';
  private purchaseStatus: string = this.applyStatusArr[0].name;
  private beforeTime: any = moment(new Date()).subtract(15, 'day').format('YYYY-MM-DD');
  private afterTime: any = moment(new Date()).subtract(-15, 'day').format('YYYY-MM-DD');
  private dateFormat = 'YYYY-MM-DD';
  private dataTime: any = [this.beforeTime, this.afterTime];
  private dataSource: any = [];
  private debouncedUse: (...args: any[]) => any =  new Debounced().use(this.pullDataSource, 1000);
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      this.getData();
      this.getSelectData();
      console.log('please login');
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private changeDeatil(id: string) {
    this.$router.push({
      path: '/flow/Purchaseing',
      query: {
        id,
      },
    });
  }
  private async onSearch(searchText: string) {
    this.debouncedUse(searchText);
  }
  private async pullDataSource(searchText: string) {
    const data: any = await this.getDataSource(searchText);
    const arr: any = [];
    if (data.length > 0) {
      data.forEach((element: any, index: number) => {
        arr.push(element.productName);
      });
      this.dataSource = arr;
    }
  }
  private getDataSource(Keyword: string) {
    return new Promise((resolve, reject) => {
      this.spinning = true;
      const that = this;
      const url = '/api/getPmInfoLike';
      const args = {
        pmName: this.searchPM,
        Keyword,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data) {
          console.log(res.data.data);
          resolve(res.data.data);
          // that.dataSource = res.data.data;
          this.spinning = false;
        }
      });
    });
  }
  private async handleChange(value: string, type: string, asinType: string) {
    const that = this;
    if ( type === 'pmName' ) {
      that.dataSource.splice(0, that.dataSource.length);
      const url = '/api/getPMTrackingProAsin';
      const args = {
        pmName: value,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data) {
          if (asinType === 'empty') {
            that.searchProductNameAsinJson = res.data.data[0];
            that.searchProductNameAsinJson.unshift({
              productName: 'ALL',
              asin: '',
            });
            that.searchProductName = '';
            that.searchAsin = '';
            // that.searchFactory = '';
          } else if ( asinType === 'asin' ) {
            that.searchProductNameAsinJson = res.data.data[0];
            that.searchProductNameAsinJson.unshift({
              productName: 'ALL',
              asin: '',
            });
          }
        }
      });
    } else if ( type === 'productName' ) {
      const args = {
        productName: value,
      };
      await this.getTrackingAll(args);
      this.searchProductNameAsinJson.forEach( (element: any) => {
        if (element.productName === value) {
          that.searchAsin = element.asin;
          // that.searchFactory = element.factory;
        }
      });
    }
  }
  private getTrackingAll(args: any) {
    return new Promise((resolve, reject) => {
      const that = this;
      // 根据 productNumber 自动填写 其他确认的数据;
      const url = '/api/getTrackingAll';
      this.axios.post(url, args).then((res) => {
        const data = res.data.data[0];
        that.searchProductName = data.productName;  // 产品名称
        that.searchPM  = data.pmName; // PM
        that.searchAsin  = data.asin; // asin
        resolve();
      });
    });
  }
  private changeSearchAsin(event: any) {
    const that = this;
    that.last = event.timeStamp;
    setTimeout(() => {
      if (that.last - event.timeStamp === 0) {
        // 你的逻辑
        const url = '/api/getPMProductInfo';
        const args = {
          asin: this.searchAsin,
          // factory: this.searchFactory,
          team: this.user.team,
        };
        that.axios.post(url, args).then((res) => {
          if (res.data.data.length > 0) {
            // that.$set(, '');
            const name = res.data.data[0].pmName;
            that.searchPM = name;
            that.searchProductName = res.data.data[0].productName;
            that.handleChange(name, 'pmName', 'asin');
          } else {
            that.$message.error('暂无此asin数据!!!');
            // that.modalDisabled = false;
          }
        });
      }
    }, 900);
  }
  private async getSelectData() {
    const that = this;
    this.spinning = true;
    // 清空数组
    const url: string = '/api/getSelectTracking';
    const args = {
      team: this.user.team,
    };
    this.axios.post(url, args).then((res) => {
      that.selectDataJson = res.data.data;
      that.spinning = false;
    });
  }
  private async changePurchaseingToGoods(id: string) {
    // 检查 当前采购的id,  取 pay 和 goods 的状态,查看pay 是否都支付, goods是否 确认收货
    const flag = await this.checkPurchaseingPayOrGoods(id);
    if (!flag) {
      this.spinning = false;
      return false;
    }
    // 更改 采购的状态
    this.changePurchaseStatus(id);
  }
  private checkPurchaseingPayOrGoods(id: string) {
    return new Promise((resolve, reject) => {
      const that = this;
      this.spinning = true;
      const url: string = '/api/getIDPayOrGoodsData';
      const args = {
        id,
      };
      this.axios.post(url, args).then((res) => {
        const data = res.data.data;
        let flag = true;
        if (data[0].length === 0 || data[1].length === 0) {
          that.$message.warning('支付账单和商品收货尚未创建,请补充信息!!!');
          flag = false;
          resolve(flag);
          return false;
        }
        for (const list of data[0]) {
          if (list.financeStatus === 0) {
            flag = false;
            that.$message.warning('账单尚未完全支付,请联系财务!!!');
            resolve(flag);
            return false;
          }
        }
        for (const list of data[1]) {
          if (list.goodsStatus === 0) {
            flag = false;
            that.$message.warning('产品尚未完全确认收货,请检查!!!');
            resolve(flag);
            return false;
          }
        }
        resolve(flag);
      });
    }).catch((err) => {
      console.log(err);
    });

  }
  private checkPurchaseingGoods(id: string) {
    return new Promise((resolve, reject) => {
      const that = this;
      this.spinning = true;
      // 清空数组  112-0006206-7613056
      const url: string = '/api/getPurchaseingGoods';
      const args = {
        id,
      };
      this.axios.post(url, args).then((res) => {
        resolve(res);
      });
    }).catch((err) => {
      console.log(err);
    });

  }
  private async changePurchaseStatus(id: string) {
    const that = this;
    this.spinning = true;
    // 清空数组  112-0006206-7613056
    const url: string = '/api/changePurchaseStatus';
    const args = {
      id,
      purchaseStatus: 2,
    };
    const data = await this.axios.post(url, args);
    this.getData();
  }
  private async getData() {
    const that = this;
    this.spinning = true;
    // 清空数组  112-0006206-7613056
    const url: string = '/api/getPurchaseingListPayGoods';
    const args = {
      purchaseStatus: this.purchaseStatus,
      pmName: this.searchPM,
      asin: this.searchAsin,
      dataTime: this.dataTime,
      factory: this.searchFactory,
    };
    const data = await this.axios.post(url, args);
    this.dataJson = data.data.data;
    this.spinning = false;
  }
  private returnPayStatus(status: number) {
    if (status === 3) {
      return true;
    } else {
      return false;
    }
  }
  private returnGoodsStatus(status: number) {
    if (status === 1) {
      return true;
    } else {
      return false;
    }
  }
  private showConfirmDelete(id: string) {
    const that = this;
    this.$confirm({
      title: '确定要删除吗!!!',
      content: `支付及仓储物流都会删除!!!`,
      onOk() {
        that.delectPurchaseIdAiiInfo(id);
      },
    });
  }
  private delectPurchaseIdAiiInfo(id: string) {
    const that = this;
    const url: string = '/api/delectPurchaseIdAiiInfo';
    const args = {
      id,
    };
    this.axios.post(url, args).then((res) => {
      const data = res.data;
      if (data.code === 7) {
        that.$message.success(data.msg);
        that.getData();
      } else if (data.code === 12) {
        that.$message.warning(data.msg);
      }
    });
  }
  private onPickerChange(date: any, dateString: string) {
    this.dataTime = dateString;
  }
  private getCurrentStyle(current: any, today: any): any {
    const style: any = {};
    if (current.date() === 1) {
      style.border = '1px solid #1890ff';
      style.borderRadius = '50%';
    }
    return style;
  }

}
